import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Stack from 'components/Stack';
import Text from 'components/Text';

import { color, media } from 'styles/utils';

const StyledContainer = styled.div`
  background-color: ${color('white')};
  border-radius: 0.5rem;
  padding: 1.5rem;
`;

const StyledTitle = styled(Text)`
  font-weight: bold;
`;

const StyledList = styled.ul`
  padding: 0 1rem;

  li,
  a {
    font-size: 0.875rem;
    line-height: 1.5;
    color: ${color('mediumTeal')};
  }

  li + li {
    padding-block-start: 0.5rem;
  }

  a {
    transition: color 150ms ease-in-out;
    text-decoration: none;
  }

  ${media.hover} {
    a:hover {
      color: ${color('lightTeal')};
      text-decoration: underline;
    }
  }
`;

export default function TableOfContents({ title, items, scrollOffset }) {
  if (!items.length) {
    return null;
  }

  return (
    <StyledContainer>
      <Stack gap="1rem">
        <StyledTitle variant="smallestP" color="darkTeal">
          TABLE OF CONTENTS
        </StyledTitle>
        {title && (
          <StyledTitle variant="smallestP" color="mediumTeal">
            {title}
          </StyledTitle>
        )}
        <StyledList>
          {items.map((i, index) => (
            <li key={index}>
              <a href={`#id-${i.key}`}>{i.text}</a>
            </li>
          ))}
        </StyledList>
      </Stack>
    </StyledContainer>
  );
}

TableOfContents.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  scrollOffset: PropTypes.number,
};

TableOfContents.defaultProps = {
  scrollOffset: -100,
};
